import styled, { css } from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import Input from '@carvana/showroom-forms/Input';
import Radio from '@carvana/showroom-forms/Radio';
import Checkbox from '@carvana/showroom-forms/Checkbox';
import NativeLink from '../../common/NativeLink';

const ScheduleText = styled.p`
  ${(props) => props.theme.font.label.v200};
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v200};
  margin: 0;
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.label.v300};
  }
`;

const ScheduleDate = styled.p`
  ${(props) => props.theme.font.label.v400};
  font-weight: ${(props) => props.theme.font.weight.v300};
  color: ${(props) => props.theme.color.primary.v600};
  margin: 10px 0 0;
`;

const EditLink = styled(NativeLink)`
  ${(props) => props.theme.font.label.v300};
  color: ${(props) => props.theme.color.primary.v200};
  font-weight: ${(props) => props.theme.font.weight.v200};
  text-decoration: underline;
  background: transparent;
  border: none;
  padding: 0 0 0 10px;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.color.primary.v200};
  }
`;

const OneTimePayDetailsWrapper = styled.div`
  align-content: flex-start;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  margin: 0;
  color: ${(props) => props.theme.color.primary.v600};

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    max-width: 1060px;
    min-height: 320px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xxl}px) {
    margin: 0;
  }
`;

const OneTimePayDueDateWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 24px;
`;

const OneTimePayAmountDueWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
  max-width: 330px;
  width: 100%;
  flex-wrap: nowrap;
  font-size: 16px;
  line-height: 24px;
  align-items: flex-start;

  #otherAmountDue + .radio__outline {
    margin-right: 10px;
  }

  // @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
  //   max-width: 330px;
  // }
`;

const OneTimePayDefaultAmountDueWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0 0px 0;
  max-width: 330px;
  margin: 20px 0 32px 0;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  color: #6d7184;

  #minAmountDue + .radio__outline {
    margin-right: 10px;
  }

  @media (min-width: 340px) {
    flex-wrap: nowrap;
  }
`;

const OneTimePayDefaultAmount = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  padding-left: 36px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;

  @media (min-width: 340px) {
    padding: 0;
  }
`;

const OneTimePayDateWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: column;
  margin: 0 0 30px 36px;
  font-size: 16px;
  line-height: 24px;
`;

const OneTimePayDetailsRadio = styled(Radio)`
  margin: 15px 0 0 0;

  // & Input[type='radio']:checked + div.radio__outline {
  //   border-color: #00619e;
  // }

  // & Input[type='radio']:checked + div.radio__outline > div.radio__dot {
  //   background-color: #00619e;
  // }

  @media (min-width: 340px) {
    margin: 15px 0;
  }
`;

const OneTimePayDetailsInput = styled(Input)`
  & Input {
    font-weight: normal;
    // color: #aab1c7;
    background: #fff;
  }

  & Label {
    color: #aab1c7;
  }

  & Input[disabled] {
    background: #fff;
  }

  & Input:not([disabled]) {
    background: #fff;
  }

  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  & input[type='number'] {
    -moz-appearance: textfield;
  }

  @media screen and (max-width: 767px) {
    & Input:not([disabled]) {
      font-size: 16px;
    }
  }
`;

const OneTimePayConsentWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
  max-width: 630px;
  font-size: 16px;
  line-height: 24px;

  a {
    color: ${(props) => props.theme.color.primary.v200};
    text-decoration: underline;
  }
`;

const OneTimePayButton = css`
  padding: 0;
  width: 100%;
  min-width: 200px;
  min-height: 56px;
  font-size: 14px;
  margin-top: 32px;
  // margin-right: 14px;
`;

const OneTimePayScheduleButton = styled(PrimaryButton)`
  ${OneTimePayButton}

  @media (min-width: 376px) {
    max-width: 250px;
    text-align: center;
    margin-right: 14px;
  }
`;

const OneTimePayDetailsCheckbox = styled(Checkbox)`
  margin-top: 4px;
  margin-bottom: 40px;
  align-items: flex-start;

  & + div {
    color: #6d7184;
  }
`;

export {
  ScheduleText,
  ScheduleDate,
  EditLink,
  OneTimePayDetailsWrapper,
  OneTimePayDueDateWrapper,
  OneTimePayAmountDueWrapper,
  OneTimePayDefaultAmountDueWrapper,
  OneTimePayDetailsRadio,
  OneTimePayDetailsInput,
  OneTimePayDefaultAmount,
  OneTimePayConsentWrapper,
  OneTimePayScheduleButton,
  OneTimePayDetailsCheckbox,
  OneTimePayDateWrapper,
};
